import Vue from "vue";
import VueResource from "vue-resource";
import VueI18n from 'vue-i18n';
import Vue2TouchEvents from 'vue2-touch-events'

import availabilityEntrypage from "./app/availabilityentrypage";

export const availabilityEntrypageInit = {
    init: () => {
        const availabilityEntrypageShells = document.querySelectorAll('.ave__container');

        if (availabilityEntrypageShells.length > 0) {
            Vue.use(VueResource);
            Vue.use(VueI18n);
            Vue.use(Vue2TouchEvents);
        }

        for (const availabilityEntrypageShell of availabilityEntrypageShells) {
            let lines = [];
            if (availabilityEntrypageShell.dataset.eyecatcherLine1) {
                lines.push(availabilityEntrypageShell.dataset.eyecatcherLine1);
            }
            if (availabilityEntrypageShell.dataset.eyecatcherLine2) {
                lines.push(availabilityEntrypageShell.dataset.eyecatcherLine2);
            }
            if (availabilityEntrypageShell.dataset.eyecatcherLine3) {
                lines.push(availabilityEntrypageShell.dataset.eyecatcherLine3);
            }

            new Vue({
                render: h => h(availabilityEntrypage, {
                    props: {
                        eyecatcherLines: lines
                    }
                }),
                i18n: new VueI18n({
                    locale: 'availability-entrypage', // set locale
                    messages: window.availabilityEntrypage_I18N // set locale messages
                }),
            }).$mount(availabilityEntrypageShell);
        }
    }
};
